module.exports = __webpack_public_path__ + "img/bl-back.ed26b542.png";